/**
 * @fileoverview gRPC-Web generated client stub for acompanha.payment_fees.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/payment_fees/v1/payment_fees.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.payment_fees = {};
proto.acompanha.payment_fees.v1 = require('./payment_fees_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.payment_fees.v1.PaymentFeesServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.payment_fees.v1.PaymentFeesServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.payment_fees.v1.ListPaymentFeesRequest,
 *   !proto.acompanha.payment_fees.v1.ListPaymentFeesResponse>}
 */
const methodDescriptor_PaymentFeesService_ListPaymentFees = new grpc.web.MethodDescriptor(
  '/acompanha.payment_fees.v1.PaymentFeesService/ListPaymentFees',
  grpc.web.MethodType.UNARY,
  proto.acompanha.payment_fees.v1.ListPaymentFeesRequest,
  proto.acompanha.payment_fees.v1.ListPaymentFeesResponse,
  /**
   * @param {!proto.acompanha.payment_fees.v1.ListPaymentFeesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.payment_fees.v1.ListPaymentFeesResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.payment_fees.v1.ListPaymentFeesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.payment_fees.v1.ListPaymentFeesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.payment_fees.v1.ListPaymentFeesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.payment_fees.v1.PaymentFeesServiceClient.prototype.listPaymentFees =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.payment_fees.v1.PaymentFeesService/ListPaymentFees',
      request,
      metadata || {},
      methodDescriptor_PaymentFeesService_ListPaymentFees,
      callback);
};


/**
 * @param {!proto.acompanha.payment_fees.v1.ListPaymentFeesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.payment_fees.v1.ListPaymentFeesResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.payment_fees.v1.PaymentFeesServicePromiseClient.prototype.listPaymentFees =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.payment_fees.v1.PaymentFeesService/ListPaymentFees',
      request,
      metadata || {},
      methodDescriptor_PaymentFeesService_ListPaymentFees);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest,
 *   !proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse>}
 */
const methodDescriptor_PaymentFeesService_CreatePaymentFee = new grpc.web.MethodDescriptor(
  '/acompanha.payment_fees.v1.PaymentFeesService/CreatePaymentFee',
  grpc.web.MethodType.UNARY,
  proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest,
  proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse,
  /**
   * @param {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.payment_fees.v1.PaymentFeesServiceClient.prototype.createPaymentFee =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.payment_fees.v1.PaymentFeesService/CreatePaymentFee',
      request,
      metadata || {},
      methodDescriptor_PaymentFeesService_CreatePaymentFee,
      callback);
};


/**
 * @param {!proto.acompanha.payment_fees.v1.CreatePaymentFeeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.payment_fees.v1.CreatePaymentFeeResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.payment_fees.v1.PaymentFeesServicePromiseClient.prototype.createPaymentFee =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.payment_fees.v1.PaymentFeesService/CreatePaymentFee',
      request,
      metadata || {},
      methodDescriptor_PaymentFeesService_CreatePaymentFee);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest,
 *   !proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse>}
 */
const methodDescriptor_PaymentFeesService_UpdatePaymentFee = new grpc.web.MethodDescriptor(
  '/acompanha.payment_fees.v1.PaymentFeesService/UpdatePaymentFee',
  grpc.web.MethodType.UNARY,
  proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest,
  proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse,
  /**
   * @param {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.payment_fees.v1.PaymentFeesServiceClient.prototype.updatePaymentFee =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.payment_fees.v1.PaymentFeesService/UpdatePaymentFee',
      request,
      metadata || {},
      methodDescriptor_PaymentFeesService_UpdatePaymentFee,
      callback);
};


/**
 * @param {!proto.acompanha.payment_fees.v1.UpdatePaymentFeeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.payment_fees.v1.UpdatePaymentFeeResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.payment_fees.v1.PaymentFeesServicePromiseClient.prototype.updatePaymentFee =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.payment_fees.v1.PaymentFeesService/UpdatePaymentFee',
      request,
      metadata || {},
      methodDescriptor_PaymentFeesService_UpdatePaymentFee);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_PaymentFeesService_DeletePaymentFee = new grpc.web.MethodDescriptor(
  '/acompanha.payment_fees.v1.PaymentFeesService/DeletePaymentFee',
  grpc.web.MethodType.UNARY,
  proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.payment_fees.v1.PaymentFeesServiceClient.prototype.deletePaymentFee =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.payment_fees.v1.PaymentFeesService/DeletePaymentFee',
      request,
      metadata || {},
      methodDescriptor_PaymentFeesService_DeletePaymentFee,
      callback);
};


/**
 * @param {!proto.acompanha.payment_fees.v1.DeletePaymentFeeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.payment_fees.v1.PaymentFeesServicePromiseClient.prototype.deletePaymentFee =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.payment_fees.v1.PaymentFeesService/DeletePaymentFee',
      request,
      metadata || {},
      methodDescriptor_PaymentFeesService_DeletePaymentFee);
};


module.exports = proto.acompanha.payment_fees.v1;

